module.exports = __webpack_public_path__ + "img/customized.e9e534cb.jpg";